module.exports = __webpack_public_path__ + "img/task-1.3110d8c5.png";